<span *ngFor="let pil of pils" class="ms-1 mb-1" [attr.data-testid]="uid">
    <p-tag value="{{ pil }}" [rounded]="true" [icon]="icon"></p-tag>
</span>
